import { useDisclosure } from "@mantine/hooks";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../model/MessageResponse";
import { useState, useEffect } from "react";
import { useForm } from "@mantine/form";
import { PartnersCreateModel } from "../../model/PartnersModel";
import { modals } from "@mantine/modals";
import {
  Box,
  Grid,
  LoadingOverlay,
  TextInput,
  Checkbox,
  Button,
  Textarea,
} from "@mantine/core";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositorySign } from "../../_base/_const/_constVar";

const PartnersCreateView = ({ onClose }: PartnersCreateViewProps) => {
  const [entity, setEntity] = useState<PartnersCreateModel>({
    orgId: 0,
    vendorId: 0,
    vendorName: null,
    vendorCode: null,
    enabledFlag: "N",
    startDateActive: "2024-10-24T03:17:15.681Z",
    endDateActive: "2024-10-24T03:17:15.681Z",
    vendorTypeLookupCode: null,
    employeeId: 0,
    email: null,
    phone: null,
    addr: null,
    creditLimit: 0,
    vatRegistrationNum: null,
  });
  const [visible, { close, open }] = useDisclosure(false);
  const handleSetEntity = async () => {
    let url = "https://apis-pos-dev.hacom.vn/api-sign/api/v1/TblVendor/create";

    const response = await repositorySign.get<
      MessageResponse<PartnersCreateModel>
    >(url);

    if (response && response.success) {
      setEntity(response!.data);
    } else {
      NotificationExtension.Fails("Lỗi !");
    }
  };

  const form = useForm<PartnersCreateModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    transformValues: (values) => ({
      ...values,
    }),
    validate: {
      vendorCode: (value) => {
        if (!value) {
          return "Vui lòng nhập mã đối tác!";
        }
        return null;
      },
      phone: (value) => {
        if (!value) {
          return "Vui lòng nhập số điện thoại đối tác!";
        }
        return null;
      },
      vendorName: (value) => {
        if (!value) {
          return "Vui lòng nhập tên đối tác!";
        }
        return null;
      },
      email: (value) => {
        if (!value) {
          return "Vui lòng nhập email!";
        }
        return null;
      },
      addr: (value) => {
        if (!value) {
          return "Vui lòng nhập email!";
        }
        return null;
      },
    },
  });

  const handleCreatePartner = async (payload: PartnersCreateModel) => {
    open();
    let url = "https://apis-pos-dev.hacom.vn/api-sign/api/v1/TblVendor/create";
    const response = await repositorySign.post<MessageResponse<boolean>>(
      url,
      payload
    );
    if (response?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
      NotificationExtension.Success("Tạo đối tác thành công !");
    } else {
      NotificationExtension.Fails("Tạo đối tác thất bại !");
    }
    close();
  };

  useEffect(() => {
    handleSetEntity();
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        px="10px"
        onSubmit={form.onSubmit((e: PartnersCreateModel) => {
          handleCreatePartner(e);
        })}
        style={{
          position: "relative",
          width: "500px",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid>
          <Grid.Col span={12}>
            <TextInput
              required
              label="Tên đối tác"
              placeholder="Nhập tên đối tác"
              {...form.getInputProps("vendorName")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              required
              label="Mã đối tác"
              placeholder="Nhập mã đối tác"
              {...form.getInputProps("vendorCode")}
            />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput
              required
              label="Số điện thoại"
              placeholder="Nhập số điện thoại"
              {...form.getInputProps("phone")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              required
              label="Email"
              placeholder="Nhập email"
              {...form.getInputProps("email")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label="Mã số thuế"
              placeholder="Nhập mã số thuế"
              {...form.getInputProps("vatRegistrationNum")}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Textarea
              required
              label="Địa chỉ"
              placeholder="Nhập địa chỉ"
              {...form.getInputProps("addr")}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Checkbox
              label="Sử dụng"
              {...form.getInputProps("enabledFlag")}
              onChange={(e) => {
                form.setFieldValue("enabledFlag", e.target.checked ? "Y" : "N");
              }}
            ></Checkbox>
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col
            span={12}
            display={"flex"}
            style={{ justifyContent: "flex-end", gap: "30px" }}
          >
            <Button
              type="button"
              color="gray"
              variant="outline"
              loading={visible}
              onClick={() => {
                modals.closeAll();
              }}
              leftSection={!visible ? <IconWindow size={18} /> : undefined}
            >
              Đóng
            </Button>
            <Button
              type="submit"
              color="blue"
              loading={visible}
              leftSection={!visible ? <IconCheck size={18} /> : undefined}
            >
              Lưu
            </Button>
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};

type PartnersCreateViewProps = {
  onClose: any;
};
export default PartnersCreateView;
